import React, { useState } from 'react'
import { styled } from 'styled-components'

/**
 * An image renderer. Doesn't display the image unless the image is loaded.
 * @param {{src: string}} props - the props to display the image.
 * @returns
 */
export default function Img({
	style,
	hasBorder,
	...imageAttributes
}: {
	src: string,
	style?: {},
	className?: string,
	hasBorder?: boolean,
	...
}): React$Node {
	const [loaded, setLoaded] = useState(false)

	return (
		<>
			<P style={loaded ? { ...style, display: 'none' } : style}>
				Loading image...
			</P>
			<StyledImage
				{...imageAttributes}
				style={!loaded ? { ...style, display: 'none' } : style}
				onLoad={() => {
					setLoaded(true)
				}}
				$hasBorder={hasBorder}
			/>
		</>
	)
}

const StyledImage = styled.img`
	max-width: 100%;
	max-height: 100%;
	${({ $hasBorder, theme }) =>
		$hasBorder
			? `border: ${theme.spacing} ${theme.onBase} solid;
	background-color: ${theme.base4};
	border-radius: 4px;`
			: null}
`

const P = styled.p`
	font-size: 16px;
	height: 200px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	text-align: center;
`
